import urlUtils from '../../utils/urlUtils';
import {config} from '../config';

const getStoragePath = () => config.data.storage.path;

const getAssembledExternalConfigPath = (fileName) => {
    const storagePath = getStoragePath();
    const storageFolderName = config.data.storage.externalConfig.folderName;

    if (storagePath && storageFolderName && fileName) {
        const assembledExternalConfigPath = urlUtils.join(storagePath, storageFolderName, fileName);

        return assembledExternalConfigPath;
    }
};

const getCombinedPathAssetPath = (customPath) => {
    const storagePath = getStoragePath();

    if (storagePath && customPath) {
        const combinedPath = urlUtils.join(storagePath, customPath);

        return combinedPath;
    }
};

export default {
    getExternalConfigLinksPath: () => getAssembledExternalConfigPath(config.data.storage.externalConfig.linksFileName),
    getAdConfigFileNamePath: () => getAssembledExternalConfigPath(config.data.storage.externalConfig.adConfigFileName),
    getExternalVideoGuidesConfigPath: () =>
        getAssembledExternalConfigPath(config.data.storage.externalConfig.videoGuidesConfigFileName),
    getAssetsPath: () => getCombinedPathAssetPath(config.data.storage.assetsPath),
    getHolderAssetsPath: () => getCombinedPathAssetPath(config.data.storage.holderAssetsPath),
    getReconnectGuideAssetsPath: () => getCombinedPathAssetPath(config.data.storage.reconnectGuideAssetsPath),
    getBrowserCheckPageImagePath: () => getCombinedPathAssetPath(config.data.storage.browserCheckPageImagePath),
    getCombinedPathAssetPath,
    getWelcomePageImagePath: () => config.data.storage.welcomePageImagePath,
    getLegalDisclaimerPdfName: () => config.data.storage.legalDisclaimerPdfName,
    getTradeInSmallBannerPath: () => getCombinedPathAssetPath(config.data.storage.tradeIn.smallBanner),
    getTradeInBigBannerPath: () => getCombinedPathAssetPath(config.data.storage.tradeIn.bigBanner),
    getLeviaSmallBannerPath: () => getCombinedPathAssetPath(config.data.storage.levia.smallBanner),
    getLeviaBigBannerPath: () => getCombinedPathAssetPath(config.data.storage.levia.bigBanner),
    getLearnMoreSmallBannerPath: () => getCombinedPathAssetPath(config.data.storage.learnMore.smallBanner),
    getLearnMoreBigBannerPath: () => getCombinedPathAssetPath(config.data.storage.learnMore.bigBanner),
};
